<template>
  <div class="body d-flex pb-3">
    <div class="container-xxl card">
      <div class="row align-items-center">
        <div class="border-0 mb-4">
          <div
            class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap"
          >
            <h3 class="fw-bold mb-0">Scenarios</h3>
            <div class="col-auto d-flex w-sm-100">
              <button
                type="button"
                @click.prevent="toAddUser"
                class="btn btn-primary btn-set-task w-sm-100"
                data-bs-toggle="modal"
                data-bs-target="#expadd"
              >
                <i class="icofont-plus-circle me-2 fs-6"></i>Add
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Row end  -->
      <div class="row mb-3">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div
                id="patient-table_wrapper"
                class="dataTables_wrapper dt-bootstrap5 no-footer"
              >
                <div class="row overflow-auto">
                  <div class="col-sm-12">
                    <table
                      id="patient-table"
                      class="table table-striped align-middle mb-0 nowrap dataTable no-footer dtr-inline"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="patient-table_info"
                    >
                      <thead>
                        <tr role="row">
                          <th>ID</th>
                          <th>Name</th>
                          <th>Main Category</th>
                          <th>View</th>
                          <th>Update</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="item in items" :key="item.id" class="">
                          <td>{{ item.id }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.isMain ? "Yes" : "No" }}</td>
                          <td>
                            <button
                              type="button"
                              class="btn btn-outline-secondary"
                              @click="handleView(item)"
                            >
                              <i
                                class="icofont-eye text-primary"
                                style="font-size: 20px"
                              ></i>
                            </button>
                          </td>
                          <td>
                            <!-- Update -->
                            <button
                              type="button"
                              class="btn btn-outline-secondary"
                              @click="toUpdateUser(item)"
                            >
                              <i class="icofont-edit text-success"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-secondary"
                              @click="toDeleteTemplate(item)"
                            >
                              <i class="icofont-ui-delete text-danger"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <br />
                <pagination
                  :totalPages="leng"
                  :perPage="request.pageSize"
                  :currentPage="request.currentPage"
                  @pagechanged="onPageChange"
                />
                <modal
                  name="tree"
                  height="auto"
                  styles="background-color: transparent;"
                >
                  <div class="tree-modal">
                    <div class="tree-box">
                      <div class="tree-header">
                        <h5>Scenario Tree</h5>
                        <button
                          class="btn-close"
                          @click="$modal.hide('tree')"
                        ></button>
                      </div>

                      <div class="tree-scroll">
                        <svg
                          v-if="tree"
                          viewBox="0 0 240 360"
                          preserveAspectRatio="xMidYMin meet"
                        >
                          <TreeNode
                            :node="tree"
                            :x="120"
                            :y="10"
                            :parent="null"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </modal>

                <modal
                  name="delete"
                  height="auto"
                  styles="background-color: transparent;"
                >
                  <div
                    class="modal-dialog modal-dialog-centered"
                    style="margin: 0 !important; max-width: 600px !important"
                  >
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title fw-bold" id="expeditLabel">
                          Are you sure you want to delete?
                        </h5>
                        <button
                          type="button"
                          class="btn-close"
                          @click="$modal.hide('delete')"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="remove"
                          data-bs-dismiss="modal"
                        >
                          Yes
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="$modal.hide('delete')"
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                </modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jwtInterceptor from "../../jwt.interceptor";
import Pagination from "../parts/site/Pagination.vue";
import user from "../../store/user";
import TreeNode from "../parts/scenario/TreeNode.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "User",
  components: {
    Pagination,
    TreeNode,
  },
  data: () => ({
    loading: true,
    searchloading: false,
    // exportloading: false,
    tree: null,
    request: {
      pageIndex: 1,
      pageSize: 10,
    },
    totalCount: 0,
    leng: 0,
    roles: [
      { name: "Admin", id: "admin" },
      { name: "SuperAdmin", id: "superadmin" },
    ],
    items: [],
  }),
  methods: {
    searchUsers() {
      this.$router.push("/users");
    },
    handleView(item) {
      jwtInterceptor
        .get(`${this.$store.getters.getUrl}/Games/${item.id}`)
        .then((res) => {
          this.tree = this.buildTree(res.data.scenes);
          this.$modal.show("tree");
        });
    },
    buildTree(scenes) {
      const map = new Map();
      scenes.forEach((scene) => {
        map.set(scene.id, {
          id: scene.id,
          isQuestion: scene.isQuestion,
          type: "scene",
          children: [],
        });
      });
      let root = null;
      scenes.forEach((scene) => {
        const current = map.get(scene.id);
        if (scene.parentSceneId === null) root = current;
        scene.choices?.forEach((choice) => {
          if (choice.nextSceneId) {
            const child = map.get(choice.nextSceneId);
            if (child) {
              current.children.push(child);
            }
          } else if (scene.isQuestion) {
            current.children.push({
              id: `choice-${choice.id}`,
              type: "choice",
              textAz: choice.textAz,
              textEn: choice.textEn,
              isLeaf: true,
              children: [],
            });
          }
        });
      });
      return root;
    },
    toAddUser() {
      this.$router.push("/addScenario");
    },
    toUpdateUser(item) {
      user.dispatch("prepareUserUpdate", item);
      this.$router.push("/updateScenario");
    },
    toDeleteTemplate(template) {
      this.rmelm = template.id;
      this.$modal.show("delete");
    },
    remove() {
      jwtInterceptor
        .delete(this.$store.getters.getUrl + "/Scenarios/" + this.rmelm)
        .then(() => {
          this.refresh();
          this.$toast.success("Deleted", {
            position: "top-right",
          });
          this.$modal.hide("delete");
        })
        .catch((error) => {
          this.$toast.error(error.response.data.title, {
            position: "top-right",
          });
        });
    },
    onPageChange(page) {
      this.request.pageIndex = page;
      this.refresh();
    },
    refresh() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/Scenarios/GetPaged", {
          params: this.request,
        })
        .then((response) => {
          this.items = response.data.data;
          this.totalCount = response.data.totalCount;
          this.leng = response.data.totalPages;
          this.searchloading = false;
        })
        .catch((error) => {
          this.searchloading = false;
          this.$toast.error("System Error!", {
            position: "top-right",
          });
        });
    },
  },
  created() {
    this.refresh();
  },
};
</script>

<style>
[data-theme="high-contrast"] {
  .table-striped > tbody > tr:nth-of-type(odd) > * {
    color: white !important;
  }
}

.tree-modal {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  overflow-y: auto;
}

.tree-box {
  width: 100%;
  max-width: 420px;
  max-height: 85vh;
  background: #007d57;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.tree-header {
  background: #fff;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tree-scroll {
  flex: 1;
  overflow: auto;
  padding: 10px;
}

.tree-scroll svg {
  width: 100%;
  min-height: 500px;
}

@media (max-width: 768px) {
  .tree-box {
    max-width: 90vw;
  }
}
</style>
